import { Text, View, StyleSheet, Font, Image } from '@react-pdf/renderer';
import React from 'react'
import LatoRegular from '../../../Assets/Fonts/Lato-Font/Lato-Regular.ttf';
import LatoBold from '../../../Assets/Fonts/Lato-Font/Lato-Bold.ttf';
import Header from "../Header";
import Footer from "../Footer";

Font.register({
  family: 'Lato',
  fonts: [
    { src: LatoRegular, fontWeight: 400 },
    { src: LatoBold, fontWeight: 700 }
  ]
});

const styles = StyleSheet.create({
  pagewapper: {
    position: "relative",
    height: "100%"
  },
  content: {
    display: "flex",
    width: "570px",
    alignItems: "left"
  },
  contenttitle: {
    fontFamily: "Lato",
    fontWeight: 700,
    fontSize: "18px",
    lineHeight: "30px",
    color: "#426B88"
  },
  wapper: {
    width: "567px",
    fontFamily: "Lato",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "18px",
    color: "#245775"
  },
  mainContent: {
    flexGrow: 1,
    marginTop: "28px",
  },
  footer: {
    marginTop: 'auto',
  },
  table: {
    width: '100%',
  },
  tableRow: {
    flexDirection: 'row',
    paddingVertical: 2,
    alignItems: 'center',
  },
  tableHeader: {
    paddingVertical: 1,
    fontWeight: 400,
    border: '0px',
    backgroundColor: '#245775',
    fontWeight: 'bold',
    color: 'white',
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
  },
  headerCell: { color: 'white', fontWeight: 400, paddingVertical: "5px" },
  cellQuestion: { width: '70%', fontSize: 10, color: "#394554", fontWeight: 400 },
  cellScore: { width: '7%', textAlign: 'center', fontSize: 10 },
  cell: {
    padding: "10px",
    textAlign: "left",
  },

  rowEven: {
    backgroundColor: "#F1F3F3",
  },
  rowOdd: {
    backgroundColor: "#FFF",
  },
  redRectangle: {
    width: 17,
    height: 17,
    backgroundColor: '#B6111F',
    borderRadius: "1.34px",
  },

});

const truncateText = (text, limit) => {
  if (text.length <= limit) return text;
  return text.substring(0, text.lastIndexOf(" ", limit)) + "...";
};

const getLastFilledIndex = (scores) => {
  for (let i = scores.length - 1; i >= 0; i--) {
    if (scores[i] === 1) return i;
  }
  return -1;
};

const renderRectangle = (score, index, scores) => {
  const lastFilledIndex = getLastFilledIndex(scores);
  return index <= lastFilledIndex ? <View style={styles.redRectangle} /> : null;
};

const CollaborativePage = () => (
  <View style={styles.pagewapper}>
    <Header />
    <View style={styles.content}>
      <Text style={styles.contenttitle}>COLLABORATIVE LEADERSHIP IN FOCUS</Text>
      <View style={styles.wapper}>
        <Text>
          This chart isolates the items related to Collaborative Leadership based on the combined ratings of participants. The response scale runs from 1 (Least) to 4 (Most). Any unselected statement will appear blank in the In Focus section.            </Text>
      </View>
    </View>
    <View style={styles.mainContent}>
      <View style={[styles.tableRow, styles.tableHeader]}>
        <Text style={[styles.cell, styles.cellQuestion, styles.headerCell]}>Collaborative</Text>
        {[1, 2, 3, 4].map((num) => (
          <Text key={num} style={[styles.cell, styles.cellScore, styles.headerCell]}>
            {num}
          </Text>
        ))}
      </View>

      {data.map((item, index) => (
        <View key={index} style={[styles.tableRow, index % 2 === 0 ? styles.rowEven : styles.rowOdd]}>
          <Text style={[styles.cell, styles.cellQuestion]}>{truncateText(item.question, 80)}</Text>
          {item.scores.map((score, idx) => (
            <View key={idx} style={[styles.cell, styles.cellScore]}>
              {renderRectangle(score, idx, item.scores)}
            </View>
          ))}
        </View>
      ))}
    </View>
    <Footer />
  </View>
);

export default CollaborativePage;


const data = [
  {
    "quadrant": "COLLABORATIVE",
    "question": "When leading through conflict, I am attuned to the feelings everyone is experiencing",
    "scores": [1, 1, 1, 1]
  },
  {
    "quadrant": "COLLABORATIVE",
    "question": "I am at my best when I feel more deeply connected to others.",
    "scores": [1, 1, 1, 1]
  },
  {
    "quadrant": "COLLABORATIVE",
    "question": "I want to build an emotionally intelligent organization.",
    "scores": [1, 1, 1, 1]
  },
  {
    "quadrant": "COLLABORATIVE",
    "question": "I believe relationships of trust are essential to create a successful organization.",
    "scores": [1, 1, 1, 1]
  },
  {
    "quadrant": "COLLABORATIVE",
    "question": "I believe relationships of trust are essential to create a successful organization.",
    "scores": [1, 1, 1, 0]
  },
  {
    "quadrant": "COLLABORATIVE",
    "question": "I am motivated to help my team connect more deeply with each other.",
    "scores": [1, 1, 1, 0]
  },
  {
    "quadrant": "COLLABORATIVE",
    "question": "I find fulfillment in developing a collaborative leadership culture.",
    "scores": [1, 1, 1, 0]
  },
  {
    "quadrant": "COLLABORATIVE",
    "question": "I develop others by first getting buy-in on our shared values",
    "scores": [1, 1, 0, 0]
  },
  {
    "quadrant": "COLLABORATIVE",
    "question": " I enjoy building an empowering culture at work. ",
    "scores": [1, 0, 0, 0]
  },
  {
    "quadrant": "COLLABORATIVE",
    "question": "I want our people to be fully engaged in the decision-making process.",
    "scores": [1, 0, 0, 0]
  },
  {
    "quadrant": "COLLABORATIVE",
    "question": "I want our people to be fully engaged in the decision-making process.",
    "scores": [1, 0, 0, 0]
  }
]
